import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppliedTheme } from '@xing-com/hub';
import { IconNotificationCenter } from '@xing-com/icons';
import { Marker, type MarkerVariant } from '@xing-com/marker';

import { Container } from './card-type.styled';

type CardTypeProps = {
  type: 'TakenJob' | 'AvailableJob';
  condensed?: boolean;
  className?: string;
};

type CardTypeMap = {
  [key: string]: {
    copy: string;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    variant: MarkerVariant;
    variantOnDark?: MarkerVariant;
  };
};

const map: CardTypeMap = {
  TakenJob: {
    copy: 'DREAM_MACHINE_JOB_CARD_TYPE_OCCUPIED_COMPACT',
    icon: IconNotificationCenter,
    variant: 'onColorStrong',
    variantOnDark: 'onColor',
  },
  AvailableJob: {
    copy: 'DREAM_MACHINE_JOB_CARD_TYPE_AVAILABLE_SS',
    variant: 'strong',
  },
};

export const CardType: React.FC<CardTypeProps> = ({
  type,
  condensed,
  className,
}) => {
  const isDarkMode = useAppliedTheme() === 'dark';

  return (
    <Container className={className}>
      <Marker
        icon={!condensed ? map[type].icon : undefined}
        variant={
          isDarkMode
            ? map[type].variantOnDark || map[type].variant
            : map[type].variant
        }
      >
        <FormattedMessage id={map[type].copy} defaultMessage={map[type].copy} />
      </Marker>
    </Container>
  );
};
